import create from 'zustand';

const useMenuStore = create((set) => ({
    showMenu: true,
    setShowMenu: (value) => set(state => ({
        showMenu: value
    })), 
}));

export default useMenuStore;